import { FunctionalComponent, h } from '@stencil/core';

interface MenuItem {
    label: string;
    url: string;
    children?: MenuItem[];
}

interface MenuProps {
    openMenuName?: string;
    items?: MenuItem[];
    className?: string;
}

export const Menu: FunctionalComponent<MenuProps> = ({
    openMenuName = null
}) => {
    const openSearch = () => {
        document.querySelector(".e-header__center-wrap.default.show")?.classList.remove('show');
        document.querySelector(".e-header__center-wrap.search")?.classList.add('show');
    };

    const handleSubMenuLinkClick = (event: MouseEvent) => {
        event.preventDefault();

        // Get the clicked submenu item
        const clickedItem = event.currentTarget as HTMLElement;

        // If the clicked item already has the open--nested-menu class, do nothing
        if (clickedItem.classList.contains('open--nested-menu')) {
            return;
        }

        // Find all submenu items with the open--nested-menu class and remove it
        const parentContainer = clickedItem.closest('.e-sub-menu');
        const openItems = parentContainer ? parentContainer.querySelectorAll('.e-sub-menu__item.has--nested-menu.open--nested-menu') : [];

        openItems.forEach(item => {
            if (item !== clickedItem) {
                item.classList.remove('open--nested-menu');
            }
        });

        // Add the open--nested-menu class to the clicked item
        clickedItem.classList.add('open--nested-menu');
    };

    return (
        <div class="e-header__center-wrap default show">
            <div class="e-header__menu">
                <ul class="e-main-menu" role="menu">
                    <li class="e-main-menu__item has--sub-menu e-header-top-item"
                        data-tabular="industries"
                        aria-expanded="false"
                        aria-haspopup="menu">
                        <div class="e-main-menu__title">
                            <button type="button" class="e-main-menu__link gtm-category-menu">
                                Industries
                            </button>
                            <button type="button"
                                class="e-main-menu__next menu-navigate-icon menu-navigate-icon--next"
                                aria-label="Open">
                                <i class="icon icon-arrow-right"></i>
                            </button>
                        </div>
                        <div class={`e-main-menu__inner ${openMenuName === 'industries' ? 'show' : ''}`}>
                            <div class="e-main-menu__wrap">
                                <div class="e-main-menu__title">
                                    <button type="button"
                                        class="e-main-menu__prev menu-navigate-icon menu-navigate-icon--prev"
                                        aria-label="Back">
                                        <i class="icon icon-arrow-left"></i>
                                    </button>
                                    <button type="button"
                                        class="e-main-menu__link link--sub gtm-category-menu">
                                        Our solutions
                                    </button>
                                </div>
                                <div class="e-main-menu__sub">
                                    <ul class="e-sub-menu e-tab-menu sub-col" role="menu">
                                        <li id="one" class="e-sub-menu__item has--nested-menu open--nested-menu" onClick={handleSubMenuLinkClick}>
                                            <div class="e-sub-menu__title">
                                                <span class="e-sub-menu__link gtm-category-menu">
                                                    Industries
                                                </span>
                                                <button type="button"
                                                    class="e-sub-menu__next menu-navigate-icon menu-navigate-icon--next"
                                                    aria-label="Open">
                                                    <i class="icon icon-arrow-right"></i>
                                                </button>
                                            </div>
                                            <div class="e-sub-menu__inner">
                                                <div class="e-sub-menu__title">
                                                    <button type="button"
                                                        class="e-sub-menu__prev menu-navigate-icon menu-navigate-icon--prev"
                                                        aria-label="Back">
                                                        <i class="icon icon-arrow-left"></i>
                                                    </button>
                                                    <span class="e-sub-menu__link gtm-category-menu">
                                                        Primary
                                                    </span>
                                                </div>
                                                <div class="e-sub-menu__nested tabular-body">
                                                    <ul class="e-nested-menu sub-col" role="menu">
                                                        <li class="has--inner-lists" role="menuitem">
                                                            <ul role="menu">
                                                                <li role="menuitem">
                                                                    <a href="/public-safety" class="menu-item-link">
                                                                        Public Safety
                                                                    </a>
                                                                </li>
                                                                <li role="menuitem">
                                                                    <a href="/solutions/for-business/retail" class="menu-item-link">
                                                                        Retail
                                                                    </a>
                                                                </li>
                                                                <li role="menuitem">
                                                                    <a href="/solutions/for-business/restaurants" class="menu-item-link">
                                                                        Restaurants
                                                                    </a>
                                                                </li>
                                                                <li role="menuitem">
                                                                    <a href="/solutions/for-public-sector/education" class="menu-item-link">
                                                                        Education
                                                                    </a>
                                                                </li>
                                                                <li role="menuitem">
                                                                    <a href="/solutions/for-public-sector/public-transit" class="menu-item-link">
                                                                        Mass transit
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                    <ul class="e-nested-menu sub-col" role="menu">
                                                        <li class="has--inner-lists" role="menuitem">
                                                            <ul role="menu">
                                                                <li role="menuitem">
                                                                    <a href="/solutions/for-business/financial-services" class="menu-item-link">
                                                                        Financial services
                                                                    </a>
                                                                </li>
                                                                <li role="menuitem">
                                                                    <a href="solutions/for-business/construction" class="menu-item-link">
                                                                        Construction
                                                                    </a>
                                                                </li>
                                                                <li role="menuitem">
                                                                    <a href="/solutions/for-business/transportation" class="menu-item-link">
                                                                        Transportation
                                                                    </a>
                                                                </li>
                                                                <li role="menuitem">
                                                                    <a href="/solutions/for-public-sector/federal" class="menu-item-link">
                                                                        Government
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="e-tab-content" style={{ height: '388px' }}></div>
                                    <div class="e-features sub-col">
                                        <div class="e-features__list">
                                            <div class="e-feature-item" role="menuitem">
                                                <a href="/about-us/contact-us"
                                                    class="e-feature-item__wrap menu-item-link"
                                                    data-menu-click="Ready to create the future?">
                                                    <div class="e-feature-item__image">
                                                        <img alt="icon"
                                                            loading="lazy"
                                                            width="82"
                                                            height="82"
                                                            decoding="async"
                                                            data-nimg="1"
                                                            src="https://cradlepoint.com/wp-content/uploads/2020/08/Helpdesk-white.svg"
                                                            style={{ color: 'transparent' }}>
                                                        </img>
                                                    </div>
                                                    <div class="e-feature-item__content">
                                                        <div class="e-feature-item__title">
                                                            Let us help
                                                        </div>
                                                        <div class="e-feature-item__excerpt">
                                                            Whether you have a product question or need technical support, we are here to guide you.
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sub-col">
                            <button type="button" class="menu-close">
                                <span>Close</span>
                                <i class="icon icon-cross-small" aria-hidden="true"></i>
                            </button>
                        </div>
                    </li>
                    <li class="e-main-menu__item has--sub-menu e-header-top-item" data-tabular="use-cases" aria-expanded="" aria-haspopup="menu">
                        <div class="e-main-menu__title">
                            <button type="button" class="e-main-menu__link gtm-category-menu" data-menu-click="Use Cases">Use Cases</button>
                            <button type="button" class="e-main-menu__next menu-navigate-icon menu-navigate-icon--next" aria-label="Open">
                                <i class="icon icon-arrow-right"></i>
                            </button>
                        </div>
                        <div class={`e-main-menu__inner ${openMenuName === 'use-cases' ? 'show' : ''}`}>
                            <div class="e-main-menu__wrap">
                                <div class="e-main-menu__title">
                                    <button type="button" class="e-main-menu__prev menu-navigate-icon menu-navigate-icon--prev" aria-label="Back">
                                        <i class="icon icon-arrow-left"></i>
                                    </button>
                                    <button type="button" class="e-main-menu__link link--sub gtm-category-menu">Use Cases</button>
                                </div>
                                <div class="e-main-menu__sub">
                                    <ul class="e-sub-menu e-tab-menu sub-col" role="menu">
                                        <li id="one" class="e-sub-menu__item has--nested-menu open--nested-menu" onClick={handleSubMenuLinkClick}>
                                            <div class="e-sub-menu__title">
                                                <a href="/en/topics" class="e-sub-menu__link gtm-category-menu menu-item-link">Categories</a>
                                                <button type="button" class="e-sub-menu__next menu-navigate-icon menu-navigate-icon--next" aria-label="Open">
                                                    <i class="icon icon-arrow-right"></i>
                                                </button>
                                            </div>
                                            <div class="e-sub-menu__inner">
                                                <div class="e-sub-menu__title">
                                                    <button type="button" class="e-sub-menu__prev menu-navigate-icon menu-navigate-icon--prev" aria-label="Back">
                                                        <i class="icon icon-arrow-left"></i>
                                                    </button>
                                                    <a href="/en/topics" class="e-sub-menu__link link--sub menu-item-link">Categories</a>
                                                </div>
                                                <div class="e-sub-menu__nested tabular-body">
                                                    <li class="has--inner-lists" role="menuitem">
                                                        <ul class="e-nested-menu sub-col" role="menu">
                                                            <li class="has--inner-lists" role="menuitem">
                                                                <ul role="menu">
                                                                    <li role="menuitem">
                                                                        <a href="/products/branch" class="menu-item-link">Fixed sites</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/products/mobile" class="menu-item-link">Vehicles</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/products/iot" class="menu-item-link">IoT</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/products/soho" class="menu-item-link">Remote work</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </div>
                                            </div>
                                        </li>
                                        <li id="two" class="e-sub-menu__item has--nested-menu" onClick={handleSubMenuLinkClick}>
                                            <div class="e-sub-menu__title">
                                                <a href="/en/reports-and-papers" class="e-sub-menu__link gtm-category-menu menu-item-link">Business need</a>
                                                <button type="button" class="e-sub-menu__next menu-navigate-icon menu-navigate-icon--next" aria-label="Open">
                                                    <i class="icon icon-arrow-right"></i>
                                                </button>
                                            </div>
                                            <div class="e-sub-menu__inner">
                                                <div class="e-sub-menu__title">
                                                    <button type="button" class="e-sub-menu__prev menu-navigate-icon menu-navigate-icon--prev" aria-label="Back">
                                                        <i class="icon icon-arrow-left"></i>
                                                    </button>
                                                    <a href="/en/reports-and-papers" class="e-sub-menu__link link--sub menu-item-link"></a>
                                                </div>
                                                <div class="e-sub-menu__nested tabular-body">
                                                    <li class="has--inner-lists" role="menuitem">
                                                        <ul class="e-nested-menu sub-col" role="menu">
                                                            <li class="has--inner-lists" role="menuitem">
                                                                <ul role="menu">
                                                                    <li role="menuitem">
                                                                        <a href="/solutions/use-cases/day-1-connectivity" class="menu-item-link">Day-1 connectivity</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/solutions/use-cases/iot-in-stores-and-offices" class="menu-item-link">IoT in stores and offices</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/solutions/use-cases/cellular-failover-and-out-of-band-management" class="menu-item-link">Failover</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/solutions/use-cases/pop-up-networks" class="menu-item-link">Pop-up network</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/solutions/use-cases/primary-wireless-for-fixed-sites" class="menu-item-link">Primary wireless</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/solutions/use-cases/work-from-home" class="menu-item-link">Work from home</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="/solutions/use-cases/cellular-for-location-based-applications-in-vehicles" class="menu-item-link">In-vehicle location apps</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="e-tab-content" style={{ height: '388px' }}></div>
                                    <div class="e-features sub-col">
                                        <div class="e-features__list">
                                            <div class="e-feature-item" role="menuitem">
                                                <a href="/about-us/contact-us" class="e-feature-item__wrap menu-item-link" data-menu-click="Ready to create the future?">
                                                    <div class="e-feature-item__image">
                                                        <img alt="icon" loading="lazy" width="82" height="82" decoding="async" data-nimg="1" src="https://cradlepoint.com/wp-content/uploads/2020/08/Helpdesk-white.svg" style={{ color: 'transparent' }} />
                                                    </div>
                                                    <div class="e-feature-item__content">
                                                        <div class="e-feature-item__title">Let us help</div>
                                                        <div class="e-feature-item__excerpt">Whether you have a product question or need technical support, we are here to guide you.</div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-col">
                                    <button type="button" class="menu-close">
                                        <span>Close</span>
                                        <i class="icon icon-cross-small" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="e-main-menu__item has--sub-menu e-header-top-item" data-tabular="about-us" aria-expanded="" aria-haspopup="menu">
                        <div class="e-main-menu__title">
                            <button type="button" class="e-main-menu__link gtm-category-menu" data-menu-click="About Us">About Us</button>
                            <button type="button" class="e-main-menu__next menu-navigate-icon menu-navigate-icon--next" aria-label="Open">
                                <i class="icon icon-arrow-right"></i>
                            </button>
                        </div>
                        <div class={`e-main-menu__inner ${openMenuName === 'about-us' ? 'show' : ''}`}>
                            <div class="e-main-menu__wrap">
                                <div class="e-main-menu__title">
                                    <button type="button" class="e-main-menu__prev menu-navigate-icon menu-navigate-icon--prev" aria-label="Back">
                                        <i class="icon icon-arrow-left"></i>
                                    </button>
                                    <button type="button" class="e-main-menu__link link--sub gtm-category-menu">About us</button>
                                </div>
                                <div class="e-main-menu__sub">
                                    <ul class="e-sub-menu e-tab-menu sub-col" role="menu">
                                        <li id="one" class="e-sub-menu__item has--nested-menu open--nested-menu" onClick={handleSubMenuLinkClick}>
                                            <div class="e-sub-menu__title">
                                                <a href="/en/topics" class="e-sub-menu__link gtm-category-menu menu-item-link">About Cradlepoint</a>
                                                <button type="button" class="e-sub-menu__next menu-navigate-icon menu-navigate-icon--next" aria-label="Open">
                                                    <i class="icon icon-arrow-right"></i>
                                                </button>
                                            </div>
                                            <div class="e-sub-menu__inner">
                                                <div class="e-sub-menu__title">
                                                    <button type="button" class="e-sub-menu__prev menu-navigate-icon menu-navigate-icon--prev" aria-label="Back">
                                                        <i class="icon icon-arrow-left"></i>
                                                    </button>
                                                    <a href="/en/topics" class="e-sub-menu__link link--sub menu-item-link">About Cradlepoint</a>
                                                </div>
                                                <div class="e-sub-menu__nested tabular-body">
                                                    <li class="has--inner-lists" role="menuitem">
                                                        <ul class="e-nested-menu sub-col" role="menu">
                                                            <li class="has--inner-lists" role="menuitem">
                                                                <ul role="menu">
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/about-us/" class="menu-item-link">Our story</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/about-us/leadership/" class="menu-item-link">Leadership</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/sustainability/" class="menu-item-link">Sustainability</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/about-us/accessibility/" class="menu-item-link">Accessibility</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/en-uk/contact-us/" class="menu-item-link">Contact us</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </div>
                                            </div>
                                        </li>
                                        <li id="two" class="e-sub-menu__item has--nested-menu" onClick={handleSubMenuLinkClick}>
                                            <div class="e-sub-menu__title">
                                                <a href="/en/reports-and-papers" class="e-sub-menu__link gtm-category-menu menu-item-link">Resources</a>
                                                <button type="button" class="e-sub-menu__next menu-navigate-icon menu-navigate-icon--next" aria-label="Open">
                                                    <i class="icon icon-arrow-right"></i>
                                                </button>
                                            </div>
                                            <div class="e-sub-menu__inner">
                                                <div class="e-sub-menu__title">
                                                    <button type="button" class="e-sub-menu__prev menu-navigate-icon menu-navigate-icon--prev" aria-label="Back">
                                                        <i class="icon icon-arrow-left"></i>
                                                    </button>
                                                    <a href="/en/reports-and-papers" class="e-sub-menu__link link--sub menu-item-link">Resources</a>
                                                </div>
                                                <div class="e-sub-menu__nested tabular-body">
                                                    <li class="has--inner-lists" role="menuitem">
                                                        <ul class="e-nested-menu sub-col" role="menu">
                                                            <li class="has--inner-lists" role="menuitem">
                                                                <ul role="menu">
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/about-us/press-releases/region/en-uk/" class="menu-item-link">Press release</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/resources/events/" class="menu-item-link">Events</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/resource-hub/" class="menu-item-link">Resource hub</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="https://resources.cradlepoint.com/?contentType=success-story&_gl=1*7sqxxk*_gcl_au*ODUxMjcxMjc1LjE2ODkyNjU1Mjk.&_ga=2.257465995.1495088177.1688999120-2074065101.1677685808/" class="menu-item-link">Customer stories</a>
                                                                    </li>
                                                                    <li role="menuitem">
                                                                        <a href="https://cradlepoint.com/resources/blog/" class="menu-item-link">Blog</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="e-tab-content" style={{ height: '388px' }}></div>
                                    <div class="e-features sub-col">
                                        <div class="e-features__list">
                                            <div class="e-feature-item" role="menuitem">
                                                <a href="/about-us/contact-us" class="e-feature-item__wrap menu-item-link" data-menu-click="Ready to create the future?">
                                                    <div class="e-feature-item__image">
                                                        <img alt="icon" loading="lazy" width="82" height="82" decoding="async" data-nimg="1" src="https://cradlepoint.com/wp-content/uploads/2020/08/Helpdesk-white.svg" style={{ color: 'transparent' }} />
                                                    </div>
                                                    <div class="e-feature-item__content">
                                                        <div class="e-feature-item__title">Let us help</div>
                                                        <div class="e-feature-item__excerpt">Whether you have a product question or need technical support, we are here to guide you.</div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sub-col">
                                        <button type="button" class="menu-close">
                                            <span>Close</span>
                                            <i class="icon icon-cross-small" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="e-header__search">
                <div class="search e-header-top-item" id="search-holder`">
                    <button class="search__toggle-btn" title="Search" tabindex="0" onClick={openSearch}>
                        <i class="icon icon-search"></i>
                    </button>
                    <div class="input-group input-group-combined bg-dark" id="search-input" data-search-url="/en/search">
                        <div class="search__input-wrap">
                            <label htmlFor="SearchPageInputField" class="sr-only">Search</label>
                            <input id="SearchPageInputField" class="search__input input-field" placeholder="Search" autocomplete="off" tabindex="0" type="search" value="" name="search" />
                            <i class="search__icon icon icon-search"></i>
                            <ul class="sac-results" role="suggestion"></ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};